import { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';

export default function PaymentStatus() {
  const { status: urlStatus } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    const processPayment = async () => {
      const mercadoPagoId = searchParams.get('payment_id');
      const paymentId = localStorage.getItem('lastPaymentId');

      if (!mercadoPagoId || !paymentId) {
        setErrorMsg('Parámetros inválidos para procesar el pago');
        setTimeout(() => navigate('/'), 2000);
        return;
      }

      const backendStatus = urlStatus === 'success' ? 'approved' : urlStatus === 'failure' ? 'rejected' : 'pending';

      try {
        const token = localStorage.getItem('token');
        const headers = token
          ? { Authorization: `Bearer ${token}` }
          : {}; // no mandes headers si no hay token

        console.log('➡️ Intentando confirmar pago con:', {
          mercadoPagoId,
          paymentId,
          status: backendStatus,
        });

        await axios.post(
          'https://api.minymol.com/payments/mark-success',
          {
            mercadoPagoId,
            paymentId,
            status: backendStatus,
          },
          { headers }
        );

        localStorage.removeItem('lastPaymentId');
      } catch (error) {
        console.error('❌ Error al confirmar pago:', error);
        setErrorMsg('No se pudo confirmar el pago');
      } finally {
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    };

    processPayment();
  }, [urlStatus, searchParams, navigate]);

  if (errorMsg) {
    return (
      <div style={{ textAlign: 'center', marginTop: '100px', fontSize: '18px' }}>
        <p>❌ {errorMsg}</p>
      </div>
    );
  }

  return <Loader />;
}